import { useTranslation } from 'react-i18next'
import { Spinner } from 'components'
import { useEffect, useState } from 'react'
import UnvDrawer from 'components/UnvDialog/UnvDrawer'
import $apiJSON from 'http/apiJSON'
import styles from '../AdminFullPage.module.scss'

function SyllabusesTab() {
  const { t } = useTranslation('common')

  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [q, setQ] = useState('')
  const [drawer, setDrawer] = useState(null)

  useEffect(() => {
    setLoading(true)
    $apiJSON
      .get('/syllabuses/')
      .then((res) => {
        const data = res?.data || res
        setItems(Array.isArray(data) ? data : data?.results || [])
      })
      .catch(() => setItems([]))
      .finally(() => setLoading(false))
  }, [])

  const filtered = items.filter((s) => {
    if (!q) return true
    const term = q.toLowerCase()
    const haystack = [s.title, s.code, s.direction, s.year]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
    return haystack.includes(term)
  })

  return (
    <div>
      <h2 className={styles.section_title}>{t('menu.syllabus')}</h2>

      <div className={styles.toolbar}>
        <input
          className="unv-input"
          placeholder={t('common.search')}
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      {loading ? (
        <div className={styles.spinner_box}>
          <Spinner.Center />
        </div>
      ) : filtered.length === 0 ? (
        <div className="unv-empty">{t('pages.syllabusesTab.no_plans')}</div>
      ) : (
        <table className="unv-table unv-table--clickable">
          <thead>
            <tr>
              <th>ID</th>
              <th>{t('common.name')}</th>
              <th>{t('diploma.col_direction')}</th>
              <th>{t('library.year')}</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((s) => (
              <tr key={s.id} onClick={() => setDrawer(s)}>
                <td>{s.id}</td>
                <td>{s.title || s.name || '—'}</td>
                <td>{s.direction?.title || s.direction || '—'}</td>
                <td>{s.year || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <UnvDrawer
        open={!!drawer}
        title={drawer?.title || drawer?.name || 'Учебный план'}
        onClose={() => setDrawer(null)}
      >
        {drawer ? (
          <div className={styles.kv}>
            <div className={styles.kv_key}>ID</div>
            <div>{drawer.id}</div>
            <div className={styles.kv_key}>{t('common.name')}</div>
            <div>{drawer.title || drawer.name || '—'}</div>
            <div className={styles.kv_key}>{t('diploma.col_direction')}</div>
            <div>{drawer.direction?.title || drawer.direction || '—'}</div>
            <div className={styles.kv_key}>{t('library.year')}</div>
            <div>{drawer.year || '—'}</div>
            <div className={styles.kv_key}>{t('assignments.description_label')}</div>
            <div>{drawer.description || '—'}</div>
          </div>
        ) : null}
      </UnvDrawer>
    </div>
  )
}

export default SyllabusesTab
